<template>
    <div class="search-main" @scroll="scrollFunction" ref="main">
      <div class="search-head">
        <div class="body-search-div">
          <H2 style="margin:0;">테리에 오신것을 환영합니다</H2>
        </div>
        <div class="body-search-div">
          <div class="body-search-div-inner">
            <img src="@/assets/search-icon.png" class="search-icon">
            <!-- <vue-typeahead-bootstrap
            v-model="searchWord"
            :data="storeList"
            :minMatchingChars="2"
            :style="{width: (clientWidth * 0.75) + 'px'}"
            placeholder="마트를 검색해 보세요"
            :serializer="s => s.STORE_NAME"
            inputClass="special-input-class"
            @input="searchStore(searchWord)">
            </vue-typeahead-bootstrap> -->
            <input type="text"
            class="search-input"
            v-debounce:300="searchStore"
            v-model="searchWord"
            placeholder="마트를 검색해 보세요">
            <img src="@/assets/search-clear.png"
            class="search-icon"
            v-if="!$empty(searchWord)"
            style="max-width:20px;max-height: 20px;"
            @click="clearSearch">
            <img src="@/assets/search-clear.png"
            class="search-icon"
            v-else
            style="max-width:20px;max-height: 20px;opacity:0;">
          </div>
        </div>
      </div>
      <div class="search-body">
        <div class="body-search-result-div" v-if="loadingFlag === 0 && !$empty(storeList)">
          <div v-for="(row, index) in storeList" :key="index" class="li-store" @click.stop="goStoreMain(row)">
            <div class="li-store-img">
              <img :src="`${row.STORE_LOGO}`" class="search-store-img">
            </div>
            <div class="li-store-info">
              <div class="info-div">
                <span class="info-span-14">{{row.STORE_NAME}}</span>
              </div>
              <div class="info-div">
                <img src="@/assets/icon_location.png" class="info-icon">
                <span class="info-span-12">{{row.STORE_ADDRESS + ' ' + row.STORE_ADDRESS_DETAIL}}</span>
              </div>
              <div class="info-div">
                <img src="@/assets/icon_phone.png" class="info-icon">
                <span class="info-span-12">{{row.STORE_TEL}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="body-firstmeat" v-else-if="loadingFlag === 0 && $empty(storeList) && firstmeat === 1">
          <div class="firstmeat-inner-2">
            <span class="title-orange">
             테리를 사용하여 장보기
            </span>
          </div>
          <div class="firstmeat-inner-1">
            <img class="title-icon" src="@/assets/icon/icon_deliivery.png" alt="">
            <span class="title-black">
             테리매장의 상품을 쉽게 배달할 수 있습니다.
            </span>
          </div>
          <div class="firstmeat-inner-1">
            <img class="title-icon" src="@/assets/icon/icon_coupon.png" alt="">
            <span class="title-black">
              테리매장의 포인트 / 쿠폰을 간편하게 관리 합니다.
            </span>
          </div>
          <div class="firstmeat-inner-1">
            <img class="title-icon" src="@/assets/icon/icon_event.png" alt="">
            <span class="title-black">
              테리매장의 할인행사 / 이벤트 알림을 받아 보세요.
            </span>
          </div>
          <div class="firstmeat-inner-1">
            <img class="title-icon" src="@/assets/icon/icon_ask.png" alt="">
            <span class="title-black">
              매장의 궁금한 점을 실시간으로 물어보세요.
            </span>
          </div>
        </div>
        <div class="body-search-result-div"
        v-else
        style="display:flex;
        align-items:center;
        justify-content: center;">
          <span class="title-searching">{{processWord}}</span>
        </div>
      </div>
    </div>
</template>
<script>
import InfiniteLoading from 'vue-infinite-loading'
import {cloneDeep} from 'lodash'
import empty from 'is-empty'
import axios from 'axios'
import * as mutations from '@/graphql/mutations'
import { API } from 'aws-amplify'
export default {
  name: 'searchMain',
  components: {
    InfiniteLoading
  },
  data () {
    return {
      searchWord: '',
      storeList: [],
      loadingFlag: 0,
      processWord: '',
      firstmeat: 1,
      debounce: '',
      clientWidth: 0,
      innerHeight: 0,
      currentPage: 0,
      size: 10,
      scrolled: false,
      key: ''
    }
  },
  created () {
    console.log('body:::', window.innerHeight)
    this.clientWidth = window.innerWidth
    this.innerHeight = window.innerHeight
  },
  mounted () {
    const vm = this
    console.log('mounted::', this.$options.name)
    // localStorage.setItem('test', 'show me the money')
    if (!vm.$empty(vm.$route.query.seq) && vm.$route.query.seq !== undefined) {
      vm.firstFunc()
    }
    this.$store.state.isLoading = false
    // alert(`${localStorage.getItem('test')}`)
  },
  methods: {
    async scrollFunction () {
      const vm = this
      if (!this.$empty(vm.searchWord)) {
        let scrollLocation = this.$refs.main.scrollTop // 현재 스크롤바 위치
        let windowHeight = window.innerHeight // 스크린 창
        let fullHeight = this.$refs.main.scrollHeight //  margin 값은 포함 x
        if (scrollLocation + windowHeight >= fullHeight) {
          var result = await getData()
          console.log('result:::', result)
        }
      }
      function getData () {
        vm.currentPage += vm.size
        return new Promise((resolve, reject) => {
          axios({
            method: 'get',
            url: `${process.env.API}/getStoreList/${vm.searchWord}/${vm.currentPage}/${vm.size}`
          })
            .then((response) => {
              if (!empty(response.data) && response.data !== 'empty') {
                vm.loadingFlag = 0
                vm.storeList.push(...response.data)
                resolve('success')
              } else if (response.data === 'empty') {
                vm.currentPage = 0
                // alert('마지막')
              } else {
                vm.loadingFlag = 1
                vm.storeList = []
                vm.processWord = '검색결과가 없습니다.'
              }
            })
        })
      }
    },
    searchStore () {
      // console.log('query:::', query)
      var query = this.searchWord
      if (!this.$empty(query)) {
        const vm = this
        this.currentPage = 0
        if (!empty(query)) {
          this.loadingFlag = 1
          this.processWord = '찾는중'
          this.debounce = setTimeout(() => {
            axios({
              method: 'get',
              url: `${process.env.API}/getStoreList/${query}/${this.currentPage}/${this.size}`
            })
              .then((response) => {
                if (!empty(response.data) && response.data !== 'empty') {
                  vm.loadingFlag = 0
                  vm.storeList = cloneDeep(response.data)
                } else if (response.data === 'empty') {
                  vm.currentPage = 0
                } else {
                  vm.loadingFlag = 1
                  vm.storeList = []
                  vm.processWord = '검색결과가 없습니다.'
                }
              })
          }, 500)
        } else {
          this.loadingFlag = 0
          this.storeList = []
        }
      }
    },
    clearSearch () {
      this.searchWord = ''
      this.loadingFlag = 0
      this.storeList = []
      this.currentPage = 0
    },
    async goStoreMain (val) {
      const vm = this
      console.log('goStoreMain :::::', val.STORE_NAME, val.STORE_SEQ)
      vm.key = val.STORE_SEQ
      !vm.$empty(vm.$route.query.eventSeq) && await vm.setKey(vm.$route.query.eventSeq)
      vm.$store.commit('setKey', vm.key)
      vm.$store.state.storeSeq = vm.$_.cloneDeep(val.STORE_SEQ)
      await vm.getStoreDeliveryInfo(val.STORE_SEQ)
      await vm.setMyUserSeq(val.STORE_SEQ)
      vm.$router.push({path: 'storeMain', query: {seq: val.STORE_SEQ}, meta: {keepAlive: false}})
      // vm.$axios({
      //   method: 'get',
      //   url: `${process.env.API}/getStoreDeliveryInfo/store/${val.STORE_SEQ}`
      // }).then(async (response) => {
      //   var delivery = response.data[0]
      //   vm.$store.state.storeDeliveryInfo = this.$_.cloneDeep(delivery)
      //   vm.$store.commit('setKey', val.STORE_SEQ)
      //   vm.$store.state.storeSeq = vm.$_.cloneDeep(val.STORE_SEQ)
      //   await vm.setMyUserSeq(val.STORE_SEQ)
      //   vm.$router.push({path: 'storeMain', query: {seq: val.STORE_SEQ}})
      // })
    },
    // async getStoreDeliveryInfo () { // 매장 배달정보 가져오기
    //   const vm = this
    //   if (!vm.$empty(vm.$store.state.storeSeq)) {
    //     console.log('getStoreDeliveryInfo :::::', vm.$store.state.storeSeq)
    //     await vm.$axios({
    //       method: 'get',
    //       url: `${process.env.API}/getStoreDeliveryInfo/store/${vm.$store.state.storeSeq}`
    //     }).then((response) => {
    //       var delivery = response.data[0]
    //       vm.$store.state.storeDeliveryInfo = this.$_.cloneDeep(delivery)
    //     })
    //   }
    // },
    async firstFunc () { // 매장정보 가져오기 (매장사진등)
      const vm = this
      await this.$axios({
        method: 'get',
        url: `${process.env.API}/getStoreInfo/store/${vm.$route.query.seq}`
      })
        .then((response) => {
          vm.storeInfo = vm.$_.cloneDeep(response.data[0])
          vm.$store.state.storeInfo = vm.$_.cloneDeep(response.data[0])
          vm.$cookies.set('storeInfo', vm.$store.state.storeInfo)
          if (response.data[0].STORE_LOGO.indexOf(',') !== -1) {
            if (response.data[0].STORE_LOGO.indexOf('sery-images') !== -1) {
              var url = response.data[0].STORE_LOGO.split(',')
              vm.storeImage = `${process.env.imgUrl}/store/${url[1]}`
            } else {
              // vm.transStoreLogo(response.data[0].STORE_LOGO)
            }
          } else {
            vm.storeImage = response.data[0].STORE_LOGO
          }
        })
    },
    async setMyUserSeq (storeSeq) {
      const vm = this
      const getMyUserSeq = localStorage.getItem(`${storeSeq}_userSeq`)
      const getMyUserIndex = localStorage.getItem(`${storeSeq}_userIndex`)
      if (!vm.$empty(getMyUserSeq) && getMyUserSeq !== 'undefined' && !vm.$empty(getMyUserIndex) && getMyUserIndex !== 'undefined') {
        return
      }
      const data = {
        storeSeq: storeSeq,
        sK: 'ROOM#LIVE',
        userIndex: 1
      }
      await API.graphql({
        query: mutations.updateStoreQnaInfoTable,
        variables: { input: data }
      }).then((response) => {
        console.log('userIndex 생성 => ', response.data)
        vm.userIndex = response.data.updateStoreQnaInfoTable.userIndex
      })
      const timeStamp = Date.now()
      const random = Math.ceil(Math.random() * 100000)
      const myUserSeq = String(timeStamp) + String(random)
      if (vm.$empty(getMyUserSeq) || getMyUserSeq === 'undefined') {
        localStorage.setItem(`${storeSeq}_userSeq`, myUserSeq)
      }
      if (vm.$empty(getMyUserIndex) || getMyUserIndex === 'undefined') {
        console.log('userIndex :::::', vm.userIndex)
        localStorage.setItem(`${storeSeq}_userIndex`, vm.userIndex)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('/css/searchMain.scss');
.special-input-class{
    background-color: #ffffff;
    color: #000000;
    width: 100%;
    height: 100%;
    min-width: 100%;
    border: 0;
    /* outline: 2px solid #6d6d6d; */
    outline: none;
    box-sizing: border-box;
    padding: 1px 0px 0px 10px;
  }
.special-input-class:focus {
    border: 0;
    width: 100%;
    height: 100%;
    border: 0;
    /* outline: 2px solid #ea4e83; */
    outline: none;
    box-sizing: border-box;
    padding: 1px 0px 0px 10px;
}
.special-highlight-class{
    font-weight: 900;
    color: #585656;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/main/searchMain.vue